import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ProfileHubProvider } from "./ProfileHubContext";
import ProfileLayout from "./components/ProfileLayout";
import ProfileOverviewSection from "./sections/ProfileOverviewSection";
import ProfileAvatarsSection from "./sections/ProfileAvatarsSection";
import ProfileBadgesSection from "./sections/ProfileBadgesSection";
import ProfileStatsSection from "./sections/ProfileStatsSection";
import ProfileHistorySection from "./sections/ProfileHistorySection";
import ProfileImageProposalsSection from "./sections/ProfileImageProposalsSection";
import ProfileRankingsSection from "./sections/ProfileRankingsSection";
import ProfileAccountSection from "./sections/ProfileAccountSection";
import ProfileFriendsSection from "./sections/ProfileFriendsSection";
import ProfileTeamSection from "./sections/ProfileTeamSection";
import ProfileBattlesSection from "./sections/ProfileBattlesSection";

export default function Profile() {
  return (
    <ProfileHubProvider>
      <ProfileLayout>
        <Routes>
          <Route index element={<ProfileOverviewSection />} />
          <Route path="avatars" element={<Navigate to="/profile/account" replace />} />
          <Route path="badges" element={<ProfileBadgesSection />} />
          <Route path="stats" element={<ProfileStatsSection />} />
          <Route path="history" element={<Navigate to="/profile" replace />} />
          <Route path="image-proposals" element={<ProfileImageProposalsSection />} />
          <Route path="rankings" element={<ProfileRankingsSection />} />
          <Route path="premium" element={<Navigate to="/profile/account" replace />} />
          <Route path="premium-social" element={<Navigate to="/profile/friends" replace />} />
          <Route path="battles" element={<ProfileBattlesSection />} />
          <Route path="friends" element={<ProfileFriendsSection />} />
          <Route path="team" element={<ProfileTeamSection />} />
          <Route path="account" element={<ProfileAccountSection />} />
          <Route path="*" element={<Navigate to="/profile" replace />} />
        </Routes>
      </ProfileLayout>
    </ProfileHubProvider>
  );
}
